/* eslint-disable */
import {IHttpClient} from '../api';
import {AppConfig} from "@/utils/enums";
import {EnvironmentConfiguration} from "@/domain/environment.configuration";

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export interface EnvironmentConfigurationResponse {
    environmentConfiguration: EnvironmentConfiguration;
}

export const EnvironmentConfigurationApi = (http: IHttpClient) => ({
    fetchEnvironmentConfiguration: () =>
        http.get<EnvironmentConfigurationResponse>(apiUrl + AppConfig.API_ENVIRONMENT_CONFIG_URL)
            .then(response => ({
                environmentConfiguration: response.data
        })),
    saveEnvironmentConfiguration: (environmentConfiguration: EnvironmentConfiguration) =>
        http.post<EnvironmentConfiguration>(apiUrl + AppConfig.API_ENVIRONMENT_CONFIG_URL, environmentConfiguration)
            .catch(error => {
                return error;
            })
});
